import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=aa81b5a8&scoped=true&"
import script from "./Contacto.vue?vue&type=script&lang=ts&"
export * from "./Contacto.vue?vue&type=script&lang=ts&"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=aa81b5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa81b5a8",
  null
  
)

export default component.exports